import { useMemo } from "react";
import { underscoreGet } from "utils/GeneralUtils";
import _ from "underscore";

const empty = [];

const useMappedOptions = ({
  options,
  globalLists,
  groupBy,
  sort,
  labelKey,
  ungroupedOptionLabel,
  groupByLabels,
  sortGroups,
  nestedGroupBy,
  addableGroups,
}) => {
  return useMemo(() => {
    if (!options?.length) {
      return empty;
    }

    if (options.includes("Global.Lists.")) {
      let mapped = [];
      const globalListName = options.split(".")[2];

      if (!globalLists) return;

      const globalList = _.findWhere(globalLists, { APIName: globalListName });

      if (!globalList) return;

      for (const variable of globalList?.Variables) {
        mapped.push(variable);
      }

      return mapped;
    }

    let mapped = options.map((opt) => {
      const newOption = _.clone(opt);

      return newOption;
    });

    if (!groupBy) {
      if (sort) {
        mapped = _.sortBy(mapped, labelKey);
      }

      return mapped;
    }

    mapped = [];

    for (let i = 0; i < options?.length; i++) {
      let group = underscoreGet(options[i], groupBy, ungroupedOptionLabel);

      // Swap out group for groupByLabel if exists
      if (groupByLabels && group) {
        const foundLabel = groupByLabels[group];

        if (foundLabel) group = foundLabel;
      }

      const idx = _.findIndex(mapped, { group });

      if (idx === -1) {
        mapped.push({
          group,
          options: [_.clone(options[i])],
        });
      } else {
        mapped[idx].options.push(_.clone(options[i]));

        mapped[idx].options = _.sortBy(mapped[idx].options, labelKey);
      }
    }

    if (sortGroups) {
      mapped = _.sortBy(mapped, "group");
    }

    if (nestedGroupBy) {
      for (const group of mapped) {
        const currentArray = group.options;
        let mappedNestedGroup = {};

        // Group tags based on TagGroup in the tag data.
        currentArray?.forEach((option) => {
          if (option[nestedGroupBy]) {
            if (!mappedNestedGroup[option[nestedGroupBy]]) {
              mappedNestedGroup[option[nestedGroupBy]] = [];
            }

            mappedNestedGroup[option[nestedGroupBy]].push(option);
          } else {
            if (!mappedNestedGroup["Additional Options"]) {
              mappedNestedGroup["Additional Options"] = [];
            }

            mappedNestedGroup["Additional Options"].push(option);
          }
        });

        group.options = mappedNestedGroup;
      }
    }

    if (groupByLabels) {
      for (let i = 0; i < groupByLabels?.length; i++) {
        const idx = _.findIndex(mapped, { group: groupByLabels[i].from });

        if (idx >= 0) {
          mapped[idx].group = groupByLabels[i].to;
        }
      }
    }

    if (addableGroups && Object.keys(addableGroups)?.length > 0) {
      for (const key in addableGroups) {
        if (!_.findWhere(mapped, { group: key })) {
          mapped.push({ group: key, options: {} });
        }
      }
    }

    return mapped;
  }, [
    options,
    groupBy,
    ungroupedOptionLabel,
    labelKey,
    groupByLabels,
    globalLists,
    nestedGroupBy,
    sort,
    sortGroups,
    addableGroups,
  ]);
};

export default useMappedOptions;
